// --------------------------------------------------------------------
// @author: shiraho@syg.com(必填, 创建模块的人员)
// @description:
// <br/>Create: new Date().toISOString()
// --------------------------------------------------------------------
var GuildSkillConst = {
    index: {
        physics: 3,           // 物理职业
        magic: 2,             // 法系职业
        defence: 4,           // 肉盾职业
        assist: 5             // 辅助职业
    },

    status: {
        un_activity: 0,
        activity: 1,
    },


}

module.exports = GuildSkillConst